import { IQuestionModel } from '@care-portals/api-interfaces';
import { IMAGE_TYPES } from '../../constants';

const questionsModels: IQuestionModel[] = [
  {
    label: 'Take a Selfie or upload one of your face holding up your ID card',
    field: 'selfieUs',
    type: 'file_upload',
    questionImage: 'https://cdn.buttercms.com/Qg4VfomnTNM4Iy7JzU2Y',
    accepts: IMAGE_TYPES,
    answer: [
      {
        resourceId: 'selfieUs',
        buttonLabel: 'Take or Upload Selfie'
      }
    ]
  }
];

export default questionsModels;
